import { call, put, takeEvery } from 'redux-saga/effects'
import {
  // get ProductListByProvider
  getListLaboratoryCategory,
  getListLaboratoryCategoryDataApiSuccess,
  getListLaboratoryCategoryDataApiFailed,

  // Sub type Category
  getListLaboratorySubCategory,
  getListLaboratorySubCategoryDataApiSuccess,
  getListLaboratorySubCategoryDataApiFailed,
  // get Lab test
  getLabTestList,
  getLabTestListApiSuccess,
  getLabTestListApiFailed,

  // lab category details
  getLaboratoryCategoryDetails,
  getLaboratoryCategoryDetailsApiSuccess,
  getLaboratoryCategoryDetailsApiFailed,
  // Sub categories Details
  getLaboratorySubCategoryDetails,
  getLaboratorySubCategoryDetailsApiSuccess,
  getLaboratorySubCategoryDetailsApiFailed,
  // Add Lab Category
  addLaboratoryCategory,
  addLaboratoryCategoryDataApiSuccess,
  addLaboratoryCategoryDataApiFailed,
  // Add lab Test
  addLabTestData,
  addLabTestDataApiSuccess,
  addLabTestDataApiFailed,
  // Add Sub Category
  addSubLaboratoryCategoryData,
  addSubLaboratoryCategoryDataApiSuccess,
  addSubLaboratoryCategoryDataApiFailed,
  // Update sab Laboratory Data
  updateSubLaboratoryCategoryData,
  updateSubLaboratoryCategoryDataApiSuccess,
  updateSubLaboratoryCategoryDataApiFailed,
  // Update Category Data
  updateLaboratoryCategoryData,
  updateLaboratoryCategoryDataApiSuccess,
  updateLaboratoryCategoryDataApiFailed,
  // delete category data
  deleteLaboratoryCategoryData,
  deleteLaboratoryCategoryDataApiSuccess,
  deleteLaboratoryCategoryDataApiFailed,
  // delete Sub Category Data
  deleteLaboratorySubCategory,
  deleteLaboratorySubCategoryApiFailed,
  deleteLaboratorySubCategoryApiSuccess,

  // update Lab Test
  updateLabTestApiData,
  updateLabTestApiSuccess,
  updateLabTestApiFailed,

  // delete Lab Test
  deleteLabTestApiData,
  deleteLabTestApiSuccess,
  deleteLabTestApiFailed,
} from './slice'
import { API } from 'src/laboratory/services/index'

function* getListLaboratoryCategoryDataApi({ payload }) {
  try {
    const response = yield call(API.manageLab.getListLaboratoryCategoryData, payload)
    if (response?.status === 200 && response?.data) {
      yield put(getListLaboratoryCategoryDataApiSuccess({ payload: response?.data }))
    } else {
      yield put(getListLaboratoryCategoryDataApiFailed({ message: response?.data?.message }))
    }
  } catch (error) {
    yield put(getListLaboratoryCategoryDataApiFailed({ message: error?.message }))
  }
}
function* getListLaboratorySubCategoryDataApi({ payload }) {
  try {
    const response = yield call(API.manageLab.getListLaboratorySubCategoryData, payload)
    if (
      response?.status === 200 &&
      response?.data
      // response?.data?.code === 0 &&
      // response?.data?.error === false
    ) {
      yield put(getListLaboratorySubCategoryDataApiSuccess({ payload: response?.data }))
    } else {
      yield put(getListLaboratorySubCategoryDataApiFailed({ message: response?.data?.message }))
    }
  } catch (error) {
    yield put(getListLaboratoryCategoryDataApiFailed({ message: error?.message }))
  }
}
function* getLabTestListApi({ payload }) {
  try {
    const response = yield call(API.manageLab.getLabTestList, payload)
    if (response?.status === 200 && response?.data) {
      yield put(getLabTestListApiSuccess({ payload: response?.data }))
    } else {
      yield put(getLabTestListApiFailed({ message: response?.data?.message }))
    }
  } catch (error) {
    yield put(getLabTestListApiFailed({ message: error?.message }))
  }
}
function* getLaboratoryCategoryDetailsApi({ payload }) {
  try {
    const response = yield call(API.manageLab.getLaboratoryCategoryDetails, payload)
    if (response?.status === 200 && response?.data) {
      yield put(getLaboratoryCategoryDetailsApiSuccess({ payload: response?.data }))
    } else {
      yield put(getLaboratoryCategoryDetailsApiFailed({ message: response?.data?.message }))
    }
  } catch (error) {
    yield put(getLaboratoryCategoryDetailsApiFailed({ message: error?.message }))
  }
}
function* getLaboratorySubCategoryDetailsApi({ payload }) {
  try {
    const response = yield call(API.manageLab.getLaboratorySubCategoryDetails, payload)
    if (
      response?.status === 200 &&
      response?.data
      // response?.data?.code === 0 &&
      // response?.data?.error === false
    ) {
      yield put(getLaboratorySubCategoryDetailsApiSuccess({ payload: response?.data }))
    } else {
      yield put(getLaboratorySubCategoryDetailsApiFailed({ message: response?.data?.message }))
    }
  } catch (error) {
    yield put(getLaboratorySubCategoryDetailsApiFailed({ message: error?.message }))
  }
}
function* addLaboratoryCategoryDataApi({ payload }) {
  try {
    const response = yield call(API.manageLab.addLaboratoryCategoryData, payload)
    if (response?.status === 200 && response?.data) {
      yield put(addLaboratoryCategoryDataApiSuccess({ payload: response?.data }))
    } else {
      yield put(addLaboratoryCategoryDataApiFailed({ message: response?.data?.message }))
    }
  } catch (error) {
    yield put(addLaboratoryCategoryDataApiFailed({ message: error?.message }))
  }
}
function* addLabTestDataApi({ payload }) {
  try {
    const response = yield call(API.manageLab.addLabTestData, payload)
    if (response?.status === 200 && response?.data) {
      yield put(addLabTestDataApiSuccess({ payload: response?.data }))
    } else {
      yield put(addLabTestDataApiFailed({ message: response?.data?.message }))
    }
  } catch (error) {
    yield put(addLabTestDataApiFailed({ message: error?.message }))
  }
}
function* addSubLaboratoryCategoryDataApi({ payload }) {
  try {
    const response = yield call(API.manageLab.addSubLaboratoryCategoryData, payload)
    if (response?.status === 200 && response?.data) {
      yield put(addSubLaboratoryCategoryDataApiSuccess({ payload: response?.data }))
    } else {
      yield put(addSubLaboratoryCategoryDataApiFailed({ message: response?.data?.message }))
    }
  } catch (error) {
    yield put(addSubLaboratoryCategoryDataApiFailed({ message: error?.message }))
  }
}
function* updateSubLaboratoryCategoryDataApi({ payload }) {
  try {
    const response = yield call(API.manageLab.updateSubLaboratoryCategoryData, payload)
    if (response?.status === 200 && response?.data) {
      yield put(updateSubLaboratoryCategoryDataApiSuccess({ payload: response?.data }))
    } else {
      yield put(updateSubLaboratoryCategoryDataApiFailed({ message: response?.data?.message }))
    }
  } catch (error) {
    yield put(updateSubLaboratoryCategoryDataApiFailed({ message: error?.message }))
  }
}
function* updateLaboratoryCategoryDataApi({ payload }) {
  try {
    const response = yield call(API.manageLab.updateLaboratoryCategoryData, payload)
    if (response?.status === 200 && response?.data) {
      yield put(updateLaboratoryCategoryDataApiSuccess({ payload: response?.data }))
    } else {
      yield put(updateLaboratoryCategoryDataApiFailed({ message: response?.data?.message }))
    }
  } catch (error) {
    yield put(updateLaboratoryCategoryDataApiFailed({ message: error?.message }))
  }
}
function* deleteLaboratoryCategoryDataApi({ payload }) {
  try {
    const response = yield call(API.manageLab.deleteLaboratoryCategoryData, payload)
    if (response?.status === 200 && response?.data) {
      yield put(deleteLaboratoryCategoryDataApiSuccess({ payload: response?.data }))
    } else {
      yield put(deleteLaboratoryCategoryDataApiFailed({ message: response?.data?.message }))
    }
  } catch (error) {
    yield put(deleteLaboratoryCategoryDataApiFailed({ message: error?.message }))
  }
}
function* deleteLaboratorySubCategoryApi({ payload }) {
  try {
    const response = yield call(API.manageLab.deleteLaboratorySubCategory, payload)
    if (response?.status === 200 && response?.data) {
      yield put(deleteLaboratorySubCategoryApiSuccess({ payload: response?.data }))
    } else {
      yield put(deleteLaboratorySubCategoryApiFailed({ message: response?.data?.message }))
    }
  } catch (error) {
    yield put(deleteLaboratorySubCategoryApiFailed({ message: error?.message }))
  }
}
function* updateLabTestApi({ payload }) {
  try {
    const response = yield call(API.manageLab.updateLabTest, payload)
    if (response?.status === 200 && response?.data) {
      yield put(updateLabTestApiSuccess({ payload: response?.data }))
    } else {
      yield put(updateLabTestApiFailed({ message: response?.data?.message }))
    }
  } catch (error) {
    yield put(updateLabTestApiFailed({ message: error?.message }))
  }
}
function* deleteLabTestApi({ payload }) {
  try {
    const response = yield call(API.manageLab.deleteLabTest, payload)
    if (response?.status === 200 && response?.data) {
      yield put(deleteLabTestApiSuccess({ payload: response?.data }))
    } else {
      yield put(deleteLabTestApiFailed({ message: response?.data?.message }))
    }
  } catch (error) {
    yield put(deleteLabTestApiFailed({ message: error?.message }))
  }
}

function* authSaga() {
  yield takeEvery(getListLaboratoryCategory, getListLaboratoryCategoryDataApi)
  yield takeEvery(getListLaboratorySubCategory, getListLaboratorySubCategoryDataApi)
  yield takeEvery(getLabTestList, getLabTestListApi)
  yield takeEvery(getLaboratoryCategoryDetails, getLaboratoryCategoryDetailsApi)
  yield takeEvery(getLaboratorySubCategoryDetails, getLaboratorySubCategoryDetailsApi)
  yield takeEvery(addLaboratoryCategory, addLaboratoryCategoryDataApi)
  yield takeEvery(addLabTestData, addLabTestDataApi)
  yield takeEvery(addSubLaboratoryCategoryData, addSubLaboratoryCategoryDataApi)
  yield takeEvery(updateSubLaboratoryCategoryData, updateSubLaboratoryCategoryDataApi)
  yield takeEvery(updateLaboratoryCategoryData, updateLaboratoryCategoryDataApi)
  yield takeEvery(deleteLaboratoryCategoryData, deleteLaboratoryCategoryDataApi)
  yield takeEvery(deleteLaboratorySubCategory, deleteLaboratorySubCategoryApi)
  yield takeEvery(updateLabTestApiData, updateLabTestApi)
  yield takeEvery(deleteLabTestApiData, deleteLabTestApi)
}

export default authSaga
